import { Component } from "react";
import { EnlacesDirectosColapsable } from "./enlacesDirectosColapsable";

export class EnlacesDirectos extends Component {
  constructor() {
    super();
    this.state = {
      configurations: {}
    };

    this.page = this.getPage();
    this.pnpService = new ServicioPnp();
    this.hideDiv = this.hideDiv.bind(this);
    console.log(this.page);
  }

  getPage() {
    const pages = {
      "Consorcio Salud": "salud",
      Salud: "salud",
      "Plan Complementario": "PC",
      "Plan de Beneficios de Salud": "PBS",
      "Servicios Premium Empresarial": "Premium Empresa",
      "Servicios Premium": "Premium Individual",
      transacciones: "Transacciones",
      default: "salud"
    };
    return pages[_spPageContextInfo.webTitle] || pages.default;
  }

  hideDiv() {
    $(this.refs["container-div"]).addClass("hidden");
    const thiscol = $(this.refs["container-div"]).closest(
      ".home-component-container"
    );
    const othercol = $(this.refs["container-div"])
      .closest(".row")
      .find(".home-component-container")
      .not(thiscol);
    if (
      thiscol[0] &&
      othercol[0] &&
      thiscol.find(".home-component").length ==
        thiscol.find(".home-component.hidden").length
    ) {
      thiscol.addClass("hidden");
      othercol
        .removeClass("col-sm-5")
        .removeClass("col-sm-6")
        .removeClass("col-sm-7")
        .addClass("col-sm-12");
    }
  }

  componentDidMount() {
    const configurations = {};

    this.pnpService.getList(
      "configuraciones",
      list => {
        list.forEach(item => {
          configurations[item.CSNombreText] = item.CSValorNote;
          this.setState({ configurations: configurations });
        });
        configurations["MensajeErrorDeServicios"] =
          configurations["MensajeErrorDeServicios"] ||
          "Discúlpenos, por favor intente más tarde";
      },
      "CSNombreText eq 'MensajeErrorDeServicios' or CSNombreText eq 'MensajeNegacionDeServicio'",
      "CSNombreText",
      "CSValorNote"
    );

    this.pnpService.getList(
      "parametrosPaginas",
      list => {
        list.forEach(item => {
          configurations[item.CSNombreText] =
            item.CSValorNote == "false" ? false : item.CSValorNote;
          configurations[item.CSNombreText + "CSVisibleBool"] =
            item.CSVisibleBool;
        });
        if (configurations["EnlacesDirectosCSVisibleBool"]) {
          this.setState({ configurations: configurations });
        } else {
          this.hideDiv();
        }
      },
      this.getPageParametersQuery()
    );
  }

  getPageParametersQuery() {
    const formListByPage = {
      PBS: "Home PBS",
      PC: "Home PC",
      salud: "Home Salud",
      "Premium Empresa": "Premium Empresa",
      "Premium Individual": "Premium Individual"
    };
    return `CSFormularioChoice eq '${formListByPage[this.page] || this.page}'`;
  }

  render() {
    return (
      <div
        className="col-md-12 home-component hide-on-message"
        id="enlacesDirectos"
        ref="container-div"
      >
        {this.state.configurations.EnlacesDirectosCSVisibleBool ? (
          <div>
            <EnlacesDirectosColapsable
              configurations={this.state.configurations}
              serviceUrl={this.page}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
